export const ZERO_STATE_ROUTE = '/';
export const TOP_RESULTS_ROUTE = '/search';
export const MORE_RESULTS_ROUTE = '/search/see-more';
export const MORE_RESULTS_CATEGORY_ROUTE = '/search/see-more/:resultType';
export const SETTINGS_ROUTE = '/settings';
export const getSeeMoreRoute = resultType => {
  return `/search/see-more/${resultType}`;
};